module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TtpYvI/image/9780369711182.jpg?1739570927004",
      "alt": "This image is the cover for the book Blues Singer to Redeem Him"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blues Singer to Redeem Him\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Nights at the speakeasy…")]), _c('br'), _c('br'), _c('i', [_vm._v("Spark a dangerous romance")]), _c('br'), _c('br'), _vm._v(" Evelyn Laroque’s performances at Lorenzo De Luca’s Kansas City blues club draw even bigger crowds than his bootleg whiskey. And every time he hears her voice, Lorenzo falls a little harder for the achingly beautiful blues singer. When Evelyn becomes a target for the KKK, Lorenzo faces an impossible choice. Will this son of a gangster turn to the mob if it’s the only way to protect the woman he loves? "), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Historical: "), _c('i', [_vm._v("Your romantic escape to the past.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elle Jackson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0